var swiperGift = new Swiper(".block_gift-idea-info-slider-next", {
    slidesPerView: 4,
    spaceBetween: 20,
    autoHeight: true,
    pagination: {
      el: ".block_gift-idea-info-slider-next .swiper-pagination",
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {     
      280: {
        slidesPerView: 1.3,
        spaceBetween: 10
      }, 
      370: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },
      576: {
        slidesPerView: 1.31,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10
      },
      989: {
        slidesPerView: 3.3,
        spaceBetween: 10
      },
      1440: {
        slidesPerView: 4.3,
        spaceBetween: 10
      }
    } 
});

var swiperGift = new Swiper(".block_gift-idea-info-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    autoHeight: true,
    pagination: {
      el: ".block_gift-idea-info-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {     
      280: {
        slidesPerView: 1,
        spaceBetween: 10
      }, 
      370: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      989: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 10
      }
    } 
});


